module.exports = __webpack_public_path__ + "img/hr-garballo-mini-dry-11.f241dc01.png";